import React, { useState } from 'react';
import Axios from '../../config/Axios';
import { isArray } from '../../helpers/functions';
import AuthLayout from './auth-layout';
import { Link, useHistory } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import { Spin } from 'antd';

const ForgetPassword = () => {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            setErrors({});
            setIsLoading(true);
            const response = await Axios.post('auth/forgot-password', {
                email,
            });
            setIsLoading(false);
            setMessage(response.data);
            setEmail('');
        } catch (error) {
            setIsLoading(false);
            const updatedFieldErrors = {};
            const data = error?.response?.data;

            if (isArray(data?.message)) {
                data?.message?.forEach((error) => {
                    updatedFieldErrors[error.field] = error.message;
                });
            } else {
            }

            setErrors(updatedFieldErrors);
        }
    };

    return (
        <AuthLayout>
            <div className="position-relative w-100">
                <div
                    className="d-flex justify-content-center p-1 rounded mb-4 position-relative"
                    style={{ backgroundColor: '#2b5c35' }}
                >
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            history.goBack();
                        }}
                        className="btn position-absolute start-0 top-50 translate-middle-y ms-3 p-0 d-flex align-items-center justify-content-center"
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.18)',
                            border: 'none',
                            color: '#ffffff',
                            transition: 'all 0.2s ease',
                            zIndex: 10
                        }}
                        title="Go Back"
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15 19.92L8.48 13.4C7.71 12.63 7.71 11.37 8.48 10.6L15 4.08"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <Link
                        className="d-flex justify-content-center align-items-center py-1 text-decoration-none"
                        to="/home"
                    >
                        <img src={logo} alt="Logo" style={{ width: '132px' }} />
                    </Link>
                </div>
                <div className={`col-12 px-0 pt-lg-0 pt-5`}>
                    <h5
                        className={`color-primary poly f-36 fw-400 lh-48 m-0 text-center`}
                    >
                        Forget Your Password?
                    </h5>
                </div>

                <div className={`col-12 px-0 pb-md-30 pb-3`}>
                    <h6
                        className={`c-667085 poppins f-14 fw-400 lh-20 m-0 text-center`}
                    >
                        please fill the information below
                    </h6>
                </div>

                {message && (
                    <div className={`centered-container`}>
                        <div className={`success-badge mb-2`}>
                            <span>{message}!</span>
                        </div>
                    </div>
                )}

                <div className={`col-12 px-md-0 position-relative`}>
                    <div className="mb-20">
                        <label
                            htmlFor="email"
                            className="form-label c-667085 poppins f-14 fw-400 lh-20"
                        >
                            Email Id <span className={`text-danger`}>*</span>
                        </label>
                        <input
                            type="email"
                            className="form-control input-filed"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your Email"
                        />

                        {errors.email && (
                            <p className={`password-error-text`}>{errors.email}</p>
                        )}
                    </div>
                </div>

                <div className={`col-12 px-md-0`}>
                    <button
                        className={`btn btn-create-acc mb-20`}
                        onClick={handleSubmit}
                    >
                        {isLoading ? <Spin /> : 'Send Mail'}
                    </button>
                </div>
            </div>
        </AuthLayout>
    );
};
export default ForgetPassword;
